import React from "react";
import "./About.css";
import AboutHero from "../components/about/AboutHero";
import AboutStory from "../components/about/AboutStory";
import AboutStats from "../components/about/AboutStats";
import ChairmanSection from "../components/about/ChairmanSection";
import BranchesSection from "../components/about/BranchesSection";
import HeadOfficeMap from "../components/about/HeadOfficeMap";
import PartnersCarousel from "../components/about/PartnersCarousel";
import AboutCTA from "../components/about/AboutCTA";
import useSiteSettings from '../hooks/useSiteSettings';
import { CardSkeleton, SkeletonText } from '../components/common/Skeleton';
export default function About() {
  const { loading } = useSiteSettings();
  if (loading) {
    return <div className="container" style={{ padding:'120px 0 60px' }}><SkeletonText width="320px" height={36} /><div style={{ marginTop:24 }}><CardSkeleton count={3} height={240} /></div></div>;
  }
  return (
    <div className="aboutPage">
      <AboutHero />
      <ChairmanSection />
      <AboutStory />
      <AboutStats />
      <BranchesSection />
      <HeadOfficeMap />
      <PartnersCarousel />
      <AboutCTA />
    </div>
  );
}
